import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import jwt_decode from "jwt-decode";
import {css} from "@emotion/core";
import axios from "axios";
import {BeatLoader} from "react-spinners";


const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}

class BankTransaction extends Component {
    constructor(props) {
        super(props);
        this.state={
            table:{},
            merchantList: [],
            chainList: [],
            merchantID: '',
            chainID: '',
            monthID: '042020',
            user_id:'',
            is_download: true,
            merchant_name: 'Reliance Retail Limited',
            stable: {},
            is_record: true,
            loading: true,
        }
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        // if (decoded.object_type == 'Admin' || decoded.object_type == 'Innoviti') {
        //     this.get_filtered_bank_tra_data('', this.state.monthID);
        // }
        // else if(decoded.object_type=='Acquiring Bank') {
        //     this.get_filtered_bank_tra_data(arrayCode, this.state.monthID);
        // }
    }
    get_filtered_bank_tra_data(bid,month){
        if ($.fn.DataTable.isDataTable('#BankTransactionTable')) {
            $('#BankTransactionTable').DataTable().clear().destroy();
        }
        this.setState({
            loading: true,
            is_record: true,

        });
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        let postdataBank = {
            banks_codes: bid,
            month: month
        };
        axios.post(config.get('API_URL')+'/invoice/bank_transaction_rows/', postdataBank,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';
                // tableHeaders.push({
                //     sTitle: "" ,
                //     mData: "id"
                //
                // });
                // tableBody.push({
                //     data: "id",
                // });

                keys.forEach(function (k) {
                    if(k=='id' || k=='latestversion') {
                        keyVal = '';
                    }
                    else{
                        keyVal = k;
                    }
                    tableHeaders.push({
                        sTitle: keyVal,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    });
                    headerList.push(k);
                });
                // console.log(JSON.stringify(tableHeaders));
                // console.log(JSON.stringify(tableBody));
                this.setState({
                    loading: false,
                    is_record: true
                });
                this.get_filtered_bank_tra_data_details(bid, month, tableHeaders, tableBody,headerList);
            }else {
                if ($.fn.DataTable.isDataTable('#MerchantTdetailsTable')) {
                    $('#MerchantTdetailsTable').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                });
            }
        })
    }
    get_filtered_bank_tra_data_details(bid, month, tableHeaders, tableBody,headerList) {
        let postdataBank = {
            banks_codes: bid,
            month: month
        };

        let total = '';
        let pageTotal = '';
        if ($.fn.DataTable.isDataTable('#BankTransactionTable')) {
            $('#BankTransactionTable').DataTable().clear().destroy();
        }

        var merchantBtrDataTable = $('#BankTransactionTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "bInfo": false,
                "pageLength": 20,
                "autoWidth": false,
                "responsive": true,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/bank_transaction_details",
                    type: 'POST',
                    data: postdataBank,
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns:tableHeaders,
                columns: tableBody,
                "columnDefs": [
                    {
                        render: function (data) {
                            return data;
                        },

                        "targets": [2, 3, 4, 6],
                        "className": "text-right"
                    },

                ],


            });

    }

    render() {
        return(
            <div className="row tansactionTabs">
                <div className="clearfix"></div>
                <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                {this.state.is_record ?
                <div className="content-tdetails-table table-full-width table-responsive">
                    <table id="BankTransactionTable" className="table table-striped table-hover">

                    </table>
                </div>:
                    <div className="empty_data"> No record Found</div>
                }
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankTransaction
